module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": "Notice of Funding Opportunity",
      "expired": _vm.expired
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid side-spacer"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    attrs: {
      "id": "grant-posting-new"
    }
  }, [_c('h1', {
    staticClass: "spacerBottom50"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("The Illinois Criminal Justice Information Authority seeks to fund a Statewide Domestic Violence Hotline Service\n            program. The grant will be made with Federal Fiscal Year 2016 (FFY16) Victim of Crime Act (VOCA) funds. A total\n            of $455,000 in funding is available through this solicitation for use over a period of 12 months.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "program-requirements"
    }
  }, [_vm._v("Program requirements")]), _vm._v(" "), _c('p', [_vm._v("The Statewide Domestic Violence Hotline Services program will fund advocates positions(s) to provide direct service\n            to victims through a statewide hotline. The City of Chicago Department of Family and Support Services may contract\n            with an external victim service provider to staff hotline services, but is required to submit at the time of\n            application a proposed contract between the agency and the victim service provider detailing advocate services\n            and costs.")]), _vm._v(" "), _c('p', [_vm._v("The funded programs will be required to submit quarterly progress reports.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligibility"
    }
  }, [_vm._v("Eligibility Information")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "eligible-applicants"
    }
  }, [_vm._v("Eligible Applicants")]), _vm._v(" "), _c('p', [_vm._v("This solicitation is open to the City of Chicago Department of Family and Support Services.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "deadline"
    }
  }, [_vm._v("Deadline")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "available-funds"
    }
  }, [_vm._v("Available Funds")]), _vm._v(" "), _c('p', [_vm._v("A total of $455,000 in funding is available through this solicitation. Funding minimum and maximum values are\n            based on the population served, according to the following standards:")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "period-of-performance"
    }
  }, [_vm._v("Period of Performance")]), _vm._v(" "), _c('p', [_vm._v("Funding is available for the period of September 1, 2018 through August 31, 2019. Based on program performance\n            and fund availability, the Authority may recommend allocation of funding to support an additional 24 months.")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "contact-information"
    }
  }, [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_vm._v("Ronnie Reichgelt")]), _vm._v(" "), _c('p', [_vm._v("Illinois Criminal Justice Information Authority")]), _vm._v(" "), _c('p', [_vm._v("300 West Adams, Suite 200")]), _vm._v(" "), _c('p', [_vm._v("Chicago, IL 60606")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "timeline"
    }
  }, [_vm._v("Timeline")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "reporting"
    }
  }, [_vm._v("Reporting")]), _vm._v(" "), _c('p', [_vm._v("The recipients must submit quarterly financial reports, quarterly progress reports, final financial and progress\n            reports, and, if applicable, an annual audit report in accordance with the CFR Part 200 Uniform Requirements.\n            Future awards and fund drawdowns may be withheld if reports are delinquent.")])])])])]), _vm._v(" "), _c('sticky-sidebar'), _vm._v(" "), _c('smooth-scroll')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 hidden-sm-down"
  }, [_c('ul', {
    staticClass: "sticky nav flex-column sidenav-toc"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "href": "#app"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#notice-of-funding-opportunity"
    }
  }, [_vm._v("Notice of Funding Opportunity")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#eligibility"
    }
  }, [_vm._v("Eligibility")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#deadline"
    }
  }, [_vm._v("Deadline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#timeline"
    }
  }, [_vm._v("Timeline")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#reporting"
    }
  }, [_vm._v("Reporting")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center",
    staticStyle: {
      "margin-bottom": "45px"
    },
    attrs: {
      "id": "notice-of-funding-opportunity"
    }
  }, [_c('a', {
    staticStyle: {
      "font-weight": "900"
    },
    attrs: {
      "href": "/static/grants/20180608VOCAHotline/VOCADVhotlineNOFO.pdf"
    }
  }, [_vm._v("Download Notice of Funding Opportunity")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Application deadline: 11:59 p.m., July 8, 2018.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("The applicant must be pre-qualified through the Grant Accountability and Transparency Act (GATA) Grantee Portal,\n            "), _c('a', {
    attrs: {
      "href": "http://www.grants.illinois.gov"
    }
  }, [_vm._v("www.grants.illinois.gov")]), _vm._v(", to become eligible to apply for an award. Applicants must have completed the GATA\n            pre-qualification process and received approval of their Internal Control Questionnaire (ICQ) by the date of\n            application to be considered for funding. Applications from agencies that have not received ICQ approval will\n            not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Completed application materials must be emailed to\n            "), _c('a', {
    attrs: {
      "href": "mailto:CJA.VOCANOFO@Illinois.gov"
    }
  }, [_vm._v("CJA.VOCANOFO@Illinois.gov")]), _vm._v(" by 11:59 p.m., July 8, 2018, to be considered for funding. Proposals will not\n            be accepted by mail, fax, or in-person. Incomplete applications will not be reviewed. Late submissions will\n            not be reviewed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "mailto:Ronnie.Reichgelt@Illinois.gov"
    }
  }, [_vm._v("Ronnie.Reichgelt@Illinois.gov")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Date")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("NOFO posted")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("June 8, 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("Applications due")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('strong', [_vm._v("11:59 p.m., July 8, 2018")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Budget Committee review/approval of recommended designation")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("August 2018")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Projected program start date")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("September 1, 2018")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-528858ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/grants/20180608VOCAHotline.vue
// module id = 375
// module chunks = 0